import React from 'react'
import { Link } from 'react-router-dom'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux'
import withStyles from "@material-ui/core/styles/withStyles";
import { compose } from 'redux'
import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";


const Navbar = (props) => {
  const { auth, profile, projects } = props;
  // console.log(auth);

  return (
    <nav className="nav-wrapper grey darken-3" >
      <div style={{display: 'flex', flexDirection: 'row'}}>
        
        
        {auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />}
      </div>
    </nav>
  )
}

const mapStateToProps = (state) => {
  // console.log(state);
  return{
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    projects: state.project.projects
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(headerStyle)
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/layout/Navbar.js